import { TableRowModel } from '@examdojo/supabase';

export type ReviewPermission =
  | 'derivative_prescreening'
  | 'derivative_expert_prescreening'
  | 'derivative_image_review'
  | 'derivative_expert_image_review'
  | 'derivative_human_review'
  | 'derivative_tie_break'
  | 'reference_image_review'
  | 'reference_expert_image_review'
  | 'reference_question_review'
  | 'reference_markscheme_review'
  | 'reference_expert_markscheme_review';

export const REVIEW_PERMISSIONS = [
  'derivative_prescreening',
  'derivative_expert_prescreening',
  'derivative_image_review',
  'derivative_expert_image_review',
  'derivative_human_review',
  'derivative_tie_break',
  'reference_image_review',
  'reference_expert_image_review',
  'reference_question_review',
  'reference_markscheme_review',
  'reference_expert_markscheme_review',
] as const satisfies ReviewPermission[];

export type UserReviewModeBindingsHttpModel = TableRowModel<'user_review_mode_bindings', 'review'>;

export type UserReviewModeBindingsPermissions = Pick<UserReviewModeBindingsHttpModel, ReviewPermission | 'syllabus_id'>;
export interface SyllabusPermissionBySyllabusId {
  syllabusId: number;
  permissions: Record<ReviewPermission, boolean>;
}

export type UpdateUserReviewPermissionsInput = SyllabusPermissionBySyllabusId[];
